import React, { useState } from 'react';
import ChatThread from './ChatThread';

const ChatBox = ({ notes, tranId, currentUserId }) => {
  const [refreshKey, setRefreshKey] = useState(0);

  const refreshMessages = () => setRefreshKey(prev => prev + 1);

  return (
    <ChatThread notes={notes} currentUserId={currentUserId} refreshKey={refreshKey} />
  );
};

export default ChatBox;

